import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    body {
      background-color: ${({ theme }) => theme.palette.background.default};
      margin: 0px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.25px;
      color: ${({ theme }) => theme.palette.text.primary};
      height: 100%;
      margin: 0px;
      padding: 0px;
    }
    html {
      height: 100%;
      margin: 0px;
      padding: 0px;
      color-scheme: dark;
    }
    #__next {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
    #root {
        height: inherit; 
           }
`;

export default GlobalStyle;
